<template>
  <div>
    <h1>SQL Reports</h1>
		<!-- <p>🌟New.  This is a placeholder for former Dataclips and other misc reports, currently it only has the Daily Taxi Trips Summary</p> -->
		<!-- <BasicTableComponent :list="list" /> -->
		<SQLReport v-model="selectedReport" />
  </div>
</template>

<script>
import sqlReports from './components/sqlReports.js'
import SQLReport from './components/SQLReport.vue'

export default {
	name:'SQLReports',
	components: {SQLReport},
  data () {return {
		selectedReport: sqlReports.daily_taxi_trips_summary,
  }},
  created () {
    // this.loadData()
  },
  methods:{
  }
  
}
</script>

<style>

</style>
